module.exports = __webpack_public_path__ + "img/red.458a966c.svg";